import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './PageTransition.css';

interface PageTransitionProps {
  isLoading: boolean;
}

const PageTransition: React.FC<PageTransitionProps> = ({ isLoading }) => {
  return (
    <AnimatePresence mode="wait">
      {isLoading && (
        <motion.div
          className="page-transition-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {/* Center Content Container */}
          <div className="center-content">
            {/* Logo with Circular Spinner */}
            <div className="logo-wrapper">
              {/* Circular Spinner */}
              <svg className="circular-spinner" viewBox="0 0 200 200">
                <circle
                  className="spinner-track"
                  cx="100"
                  cy="100"
                  r="85"
                  fill="none"
                  strokeWidth="4"
                  stroke="rgba(123, 104, 238, 0.15)"
                />
                <circle
                  className="spinner-path"
                  cx="100"
                  cy="100"
                  r="85"
                  fill="none"
                  strokeWidth="4"
                  stroke="url(#gradient)"
                  strokeLinecap="round"
                  strokeDasharray="534"
                  strokeDashoffset="400"
                />
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#7B68EE" />
                    <stop offset="50%" stopColor="#9370DB" />
                    <stop offset="100%" stopColor="#BA55D3" />
                  </linearGradient>
                </defs>
              </svg>
              
              {/* Logo Image */}
              <img 
                src="/images/YogaLogo.jpg" 
                alt="Sethumka Yoga" 
                className="transition-logo"
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageTransition;
